import { get } from "lodash";

export const GET_CURRENT_ORGANISATION_ID = "GET_CURRENT_ORGANISATION_ID";

const getters = {
  [GET_CURRENT_ORGANISATION_ID]: state => get(state, "userData.organisation.id")
};

export default getters;
